module.exports = __webpack_public_path__ + "img/moni-hagel.d0cbedde.jpg";